import React from 'react';
import { Icon } from './Icon.js';
export const IconBluetoothDots = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 7L15 17L9 21V3L15 7L3 17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("rect", { x: "14", y: "11", width: "2", height: "2", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("rect", { x: "18", y: "11", width: "2", height: "2", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("rect", { x: "22", y: "11", width: "2", height: "2", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconBluetoothDots.js.map